import { injectable } from 'inversify';
import { Floodlight, FloodlightsPerAdvertiser } from '../../../../core/dv360/model/floodlight.ts';

export type Dv360FloodlightProps = {
  id: string;
  name: string;
  insertion_order_id: string;
};

export type Dv360FloodlightsPerAdvertiserProps = {
  [advertiserId: string]: Dv360FloodlightProps[];
};

export type Dv360FloodlightsPerPlatformResponse = {
  cm360: {
    advertisers: Dv360FloodlightsPerAdvertiserProps;
  };
  dv360: {
    advertisers: Dv360FloodlightsPerAdvertiserProps;
  };
};

@injectable()
export class Dv360FloodlightMapper {
  toDeserialized(props: Dv360FloodlightProps): Floodlight {
    return {
      id: props.id,
      name: props.name,
      insertionOrderId: props.insertion_order_id,
    };
  }

  mapAdvertiserFloodlights(
    advertiserFloodlights: Dv360FloodlightsPerAdvertiserProps
  ): FloodlightsPerAdvertiser {
    return Object.entries(advertiserFloodlights).reduce(
      (acc: FloodlightsPerAdvertiser, [advertiserId, floodlights]) => {
        acc[advertiserId] = floodlights.map((floodlightProps) =>
          this.toDeserialized(floodlightProps)
        );
        return acc;
      },
      {} as FloodlightsPerAdvertiser
    );
  }
}
